export default "__VITE_ASSET__DAz14DIz__"